export enum VIP_TRANSFER_STATUS {
  FORM = 'form',
  SUCCESS = 'success',
}

export interface IVipTransferFormProps {
  onSuccess: () => void;
}
